interface Icons {
  pathName: string[];
  iconClass: string;
}

export const GenerateIcon = ({ pathName, iconClass }: Icons) => (
  <span className={iconClass}>
    {pathName.map((item: string, index: number) => (
      <span key={index} className={item} />
    ))}
  </span>
);
